/**
 * Source: https://github.com/akatov/angular-contenteditable
 * NOTE: The directive currently does not work in any version of Internet Explorer or Opera < 15. Both browsers don't fire the input event for contenteditable fields.
 */
angular.module('autoremind.directives')
    .directive('contenteditable', [
    '$timeout', '$compile', 'jobService', 'dialogs',
    function ($timeout, $compile, jobService, dialogs) {
        return {
            restrict: 'A',
            require: '?ngModel',
            scope: true,
            link: function (scope, element, attrs, ngModel) {
                //element.find('span')[0].append("&nbsp;");
                //return;
                //debugger;
                //console.log('linking ' + element.attr('ng-model'));
                // Don't do anything unless this is actually bound to a model
                if (!ngModel) {
                    return;
                }
                scope.$watch(function () {
                    return attrs.contenteditable;
                }, function () {
                    if (attrs.contenteditable === 'false') {
                        element.addClass('notEditable');
                    }
                    else {
                        element.removeClass('notEditable');
                    }
                });
                var saveSelection;
                var restoreSelection;
                if (window.getSelection && document.createRange) {
                    saveSelection = function (containerEl) {
                        var range = window.getSelection().getRangeAt(0);
                        var preSelectionRange = range.cloneRange();
                        preSelectionRange.selectNodeContents(containerEl[0]);
                        preSelectionRange.setEnd(range.startContainer, range.startOffset);
                        var start = preSelectionRange.toString().length;
                        return {
                            start: start,
                            end: start + range.toString().length
                        };
                    };
                    restoreSelection = function (containerEl, savedSel) {
                        containerEl.focus();
                        var charIndex = 0, range = document.createRange();
                        range.setStart(containerEl[0], 0);
                        range.collapse(true);
                        var nodeStack = [containerEl[0]], node, foundStart = false, stop = false;
                        console.log('nodeStack', nodeStack);
                        while (!stop && (node = nodeStack.pop())) {
                            if (node.nodeType === 3) {
                                console.log('node', node);
                                var nextCharIndex = charIndex + node.length;
                                if (!foundStart && savedSel.start + 1 > charIndex && savedSel.start + 1 <= nextCharIndex) {
                                    range.setStart(node, savedSel.start + 1 - charIndex);
                                    foundStart = true;
                                }
                                if (foundStart && savedSel.end >= charIndex && savedSel.end <= nextCharIndex) {
                                    range.setEnd(node, savedSel.end - charIndex);
                                    stop = true;
                                }
                                charIndex = nextCharIndex;
                            }
                            else {
                                var i = node.childNodes.length;
                                while (i--) {
                                    nodeStack.push(node.childNodes[i]);
                                }
                            }
                        }
                        var sel = window.getSelection();
                        sel.removeAllRanges();
                        sel.addRange(range);
                    };
                }
                else if (document.selection && document.body.createTextRange) {
                    saveSelection = function (containerEl) {
                        var selectedTextRange = document.selection.createRange();
                        var preSelectionTextRange = document.body.createTextRange();
                        preSelectionTextRange.moveToElementText(containerEl[0]);
                        preSelectionTextRange.setEndPoint("EndToStart", selectedTextRange);
                        var start = preSelectionTextRange.text.length;
                        return {
                            start: start,
                            end: start + selectedTextRange.text.length
                        };
                    };
                    restoreSelection = function (containerEl, savedSel) {
                        var textRange = document.body.createTextRange();
                        textRange.moveToElementText(containerEl[0]);
                        textRange.collapse(true);
                        textRange.moveEnd("character", savedSel.end);
                        textRange.moveStart("character", savedSel.start);
                        textRange.select();
                    };
                }
                var savedSelection;
                //console.log('element ******************', element);
                element.attr('class', Math.random());
                element.attr('id', Math.random());
                // options
                var options = {};
                angular.forEach([
                    'stripBr',
                    'stripNbsp',
                    'noLineBreaks',
                    'selectNonEditable',
                    'moveCaretToEndOnChange',
                    'limitPaste',
                ], function (opt) {
                    var o = attrs[opt];
                    options[opt] = o && o !== 'false';
                });
                // Called by added child custom directives (<comment>) to remove it from the content
                scope.remove = function (node) {
                    //alert('top remove');
                    //debugger;
                    // console.log('scope.remove', scope.viewModel.isCanBeEdited, '-----', angular.element(element).attr('contenteditable'), '//////');
                    if ((angular.isDefined(scope.viewModel.isCanBeEdited) && scope.viewModel.isCanBeEdited) || angular.element(element).attr('contenteditable') === 'true') {
                        node.remove();
                        scope.readViewText(true, scope, element);
                        //ngModel.$render();
                    }
                    else {
                        if (angular.isDefined(angular.element(element).attr('no-dialogs'))) {
                            return;
                        }
                        dialogs.notify('Note', 'The message has already been sent and it is no longer possible to edit');
                    }
                };
                // Initial value (will be set to true when model is set and element compiled)
                scope.compiled = false;
                scope.contentEdited = false;
                scope.ngModel = ngModel;
                // Wait for when model is set/changed to make sure it's compiled
                scope.$watch(function () {
                    // In stead of watching the variable we create watch function
                    // Ref: http://www.bennadel.com/blog/2852-understanding-how-to-use-scope-watch-with-controller-as-in-angularjs.htm
                    return scope.ngModel.$modelValue;
                }, function (newModelValue) {
                    // console.log('new value', element.myClass, newModelValue)
                    if (newModelValue /*&& !scope.compiled*/ && !scope.contentEdited) {
                        var html = scope.ngModel.$modelValue || '';
                        //html += '&nbsp;';
                        element.empty(); // TODO: Check if it's necessary to clean up old scopes (for memory leaks) - http://www.bennadel.com/blog/2706-always-trigger-the-destroy-event-before-removing-elements-in-angularjs-directives.htm
                        setHTML(html); // This will compile the element
                        scope.compiled = true;
                        // NOTE: If multiple contenteditable in they will share scope so scope.compiled is set on the first contenteditable so we can't rely on it for next contenteditables
                    }
                    else {
                        //scope.$emit('contentEditableChanged', ngModel);
                    }
                    scope.contentEdited = false;
                });
                // See compileExample in https://docs.angularjs.org/api/ng/service/$compile
                function setHTML(html) {
                    element.html(html);
                    $compile(element.contents())(scope); // Make sure the new html is rendered and linked to angular
                    watchForHtmlChanges();
                    scope.readViewText(); // Update model
                }
                /**
                 * Set deferred watcher for element.html()
                 */
                function watchForHtmlChanges() {
                    $timeout(function () {
                        scope.$watch(function () {
                            if (angular.isDefined(ngModel.$viewValue)) {
                                return ngModel.$viewValue;
                            }
                            else {
                                return null;
                            }
                        }, function (newVal, oldVal) {
                            if (newVal === oldVal) {
                                return;
                            }
                            if (angular.isDefined(newVal) && newVal != null
                                && newVal != oldVal) {
                                jobService.job.setEdited(true);
                            }
                        });
                    }, 0);
                }
                scope.$watch(function () {
                    if (angular.isDefined(scope.template) && angular.isDefined(scope.template.voiceMessage)) {
                        return scope.template.voiceMessage;
                    }
                    else {
                        return null;
                    }
                }, function (newVal, oldVal) {
                    if (angular.isDefined(newVal) && newVal != null
                        && newVal !== '' && newVal != oldVal) {
                        jobService.job.setEdited(true);
                    }
                });
                /**
                 * Insert html in the element at the position of the caret (and update model)
                 * NOTE: Since the scope is the same for multiple contenteditable elements (at least for email templates)
                 *       we need to call with reference to the element that got the click event (when selecting element to edit)
                 */
                scope.addHTML = function (html, selectedElement) {
                    selectedElement.focus();
                    var sel, range;
                    if (window.getSelection) {
                        // IE9 and non-IE
                        sel = window.getSelection();
                        if (sel.getRangeAt && sel.rangeCount) {
                            range = sel.getRangeAt(0);
                            range.deleteContents();
                            // Range.createContextualFragment() would be useful here but is
                            // non-standard and not supported in all browsers (IE9, for one)
                            var el = document.createElement("div");
                            el.innerHTML = html;
                            $compile(el)(scope);
                            var frag = document.createDocumentFragment(), node, lastNode;
                            while ((node = el.firstChild)) {
                                lastNode = frag.appendChild(node);
                            }
                            range.insertNode(frag);
                            // Preserve the selection
                            if (lastNode) {
                                range = range.cloneRange();
                                range.setStartAfter(lastNode);
                                range.collapse(true);
                                sel.removeAllRanges();
                                sel.addRange(range);
                            }
                        }
                    }
                    else if (document.selection && document.selection.type !== "Control") {
                        // IE < 9
                        document.selection.createRange().pasteHTML(html);
                    }
                    scope.readViewText(true, scope, element);
                    /*
                    readViewText(scope, selectedElement, function(){

                    })*/
                    //console.log('selectedElement', selectedElement, ngModel);
                    // Update model
                };
                scope.updateModelsTemplate = function () {
                    scope.readViewText(true, scope, element);
                };
                scope.$on('updateModelsTemplate', function () {
                    scope.readViewText(true, scope, element);
                });
                /**
                 * First parameter ($scope) is added by $apply(readViewText) and second (selectedElement) is
                 * either, by default, the element of the contenteditable directive being edited or the one selected
                 * before adding parameters (adding <comment> elements).
                 */
                scope.readViewText = function (isSetCaretPosition, $scope, selectedElement, callback) {
                    if (selectedElement === undefined) {
                        return;
                    }
                    if (isSetCaretPosition) {
                        savedSelection = saveSelection(selectedElement);
                    }
                    var html, html2, rerender;
                    html = angular.copy(selectedElement.html());
                    rerender = false;
                    //if (options.stripBr || options.stripBr === undefined) { // NOTE: default is to strip
                    /* Disabled because many email templates use strip-br=true when it should be false
                     * and <br> tags are handled elsewhere for SMS and voice anyway regardless of this option
                     *
                    if (options.stripBr) {
                        html = html.replace(/<br[^>]*>/g, '');
                    } else {
                        html = html.replace(/<br[^>]*>/g, '<br/>'); // Ensure that later conversion into line feed in SMS is working
                    }
                    */
                    html = html.replace(/<br[^>]*>/g, '<br/>'); // Ensure that later conversion into line feed in SMS is working
                    if (options.noLineBreaks) {
                        html2 = html.replace(/<div>/g, '').replace(/<br>/g, '').replace(/<\/div>/g, '');
                        if (html2 !== html) {
                            rerender = true;
                            html = html2;
                        }
                    }
                    // TODO: Find a better way to annotate option.stripNbsp the parent (e.g. in model table in template admin - specify which variables should be annotated)
                    //var variableName = $scope.$parent.variable.name;
                    var variableName = $scope.$parent.ngModel;
                    // Strip html spaces from variables that eventually should not reult in html
                    //if (variableName === 'smsMessage' || variableName === 'voiceMessage' || variableName === 'emailSubject') {
                    if (options.stripNbsp || variableName === 'template.smsMessage' || variableName === 'template.voiceMessage' || variableName === 'template.emailSubject') {
                        html = html.replace(/\&nbsp[;]?/g, ' ');
                    }
                    // Comment this out to see what is put in the shaddow DOM
                    html = strip_tags(html, '<br><br/><div><comment>'); // NOTE: This will NOT remove children of elements
                    //html = html.replace(/(<comment [^>]*>)([^<]*|\n)*?(<\/comment>)/g, "$1$3"); // clearing text inside of the comment tag
                    var _getViewContent = function () {
                        //var html = element.html();
                        ngModel.$setViewValue(html);
                        $timeout(function () {
                            if (isSetCaretPosition) {
                                restoreSelection(selectedElement, savedSelection);
                            }
                        });
                    };
                    $timeout(function () {
                        scope.$apply(_getViewContent);
                        if (typeof callback !== 'undefined') {
                            callback();
                        }
                    });
                    /*
                    $timeout(function(){
                        console.log(html);
                        scope.ngModel.$setViewValue(html);

                        if (rerender) {
                            scope.ngModel.$render();
                        }

                        if (html === '') {
                            // the cursor disappears if the contents is empty
                            // so we need to refocus
                            $timeout(function() {

                            });
                        }
                        console.log(angular.element(selectedElement));
                        if(typeof cb !== 'undefined'){
                            cb();
                        }


                    })
                    */
                }; // end of readViewText()
                function placeCaretAtEnd(el) {
                    el.focus();
                    if (window.getSelection) {
                        if (typeof window.getSelection != "undefined"
                            && typeof document.createRange != "undefined") {
                            var range = document.createRange();
                            range.selectNodeContents(el);
                            range.collapse(false);
                            //range.setEndBefore($(el).find('br')[0]); //only for FF, fiddle does not have browser check
                            var sel = window.getSelection();
                            sel.removeAllRanges();
                            sel.addRange(range);
                        }
                        else if (typeof document.body.createTextRange != "undefined") {
                            var textRange = document.body.createTextRange();
                            textRange.moveToElementText(el);
                            textRange.collapse(false);
                            textRange.select();
                        }
                    }
                }
                scope.selectedModel = undefined;
                // view -> model
                // TODO: Check if this conflicts with later binding to click
                element.bind('click', function (event) {
                    //console.log('click: ' + event.type + '  target:' + event.target.id);
                    //console.log('targetScope.name: ' + event.targetScope.name);
                    // TODO: Find a way to set properties directly on parent scope
                    // HACK: So far this is the cleanest solution to tell which directive instance is selected
                    //jobService.selectedContentEditableModelName = element.attr('ng-model');
                    // Set which contenteditable element is currently active for editing (with cursor)
                    //jobService.selectedContentEditableScope = scope;
                    //console.log('click: ', event.type, '  target:', element.attr('ng-model'), ' : ', ngModel);
                    scope.selectedModel = scope.ngModel;
                    // console.log('ngModel', scope.ngModel);
                    scope.$emit('contentEditableSelected', scope, scope.ngModel, element);
                    // TODO: Find a way to unset this (e.g. on blur)
                });
                // Using blur to unset does not work - clicking insert parameter element will cause blur and selecting other element to edit will also cause blur so other is not selected
                /*element.on('blur', function (event) {
                    scope.$emit('contentEditableSelected', undefined);
                });*/
                // TODO: Figure out why to do this on blur before? Doing this now on blur will not work if multiple instances - if selecting an empty one will make it impossible to visually select another
                //    element.on('blur keyup change', function (event) {
                element.on('keyup change', function (event) {
                    // console.log('blur/keyup/change: ');
                    var key = event.keyCode;
                    //if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
                    //console.log('key:' + key);
                    var sel = window.getSelection();
                    var range;
                    if (sel.getRangeAt && sel.rangeCount) {
                        range = sel.getRangeAt(0);
                        //console.log('range: ' + range.toString());
                        //console.log('start:' + start + '  end:' + end);
                        //var start = element[0].selectionStart > 3;
                        //var end = element[0].selectionEnd = parseInt(attrs.position, 10);
                        //console.log('start:' + start + '  end:' + end);
                        /*
                            if (key === 13){ //enter && shift
                                var br = document.createElement("br");
                                var textNode = document.createTextNode("\u00a0"); //Passing " " directly will not end up being shown correctly
                                range.deleteContents();//required or not?
                                range.insertNode(br);
                                range.collapse(false);
                                range.insertNode(textNode);
                                range.selectNodeContents(textNode);

                                sel.removeAllRanges();
                                sel.addRange(range);
                            }*/
                    }
                    //        var node = range.anchorNode.parentElement;
                    //console.log('node: ' + node.innerHTML);
                    //console.log('node.tagName: ' + node.tagName);
                    //        range.setStartBefore(node);
                    //        range.setEndAfter(node);
                    if (key === 39) {
                        //            if (node && node.tagName == 'SPAN') {
                        //                range.setStartAfter(node);
                        //                range.collapse();
                        //            }
                        event.stopPropagation();
                        //            return false;
                    }
                    if (key === 37) {
                        //            if (node && node.tagName == 'SPAN') {
                        //                range.setStartBefore(node);
                        //                range.collapse();
                        //            }
                        event.stopPropagation();
                        //            return false;
                    }
                    scope.$apply(scope.readViewText);
                    scope.contentEdited = true;
                    // Inform the parent scope's controller that the content was edited
                    //console.log('contentEditableChanged ' + element.attr('ng-model') + ' = ' + ngModel.$modelValue);
                    //scope.$emit('contentEditableChanged', scope.ngModel);
                    scope.readViewText(false, scope, element);
                });
                // view -> model
                /*element.bind('input', function(e) {
                    //console.log('bind');
                    scope.$apply(readViewText);
                });*/
                // model -> view
                var oldRender = scope.ngModel.$render;
                scope.ngModel.$render = function () {
                    var el, el2, range, sel;
                    if (!!oldRender) {
                        oldRender();
                    }
                    element.html(scope.ngModel.$viewValue || '');
                    if (options.moveCaretToEndOnChange) {
                        el = element[0];
                        range = document.createRange();
                        sel = window.getSelection();
                        if (el.childNodes.length > 0) {
                            el2 = el.childNodes[el.childNodes.length - 1];
                            range.setStartAfter(el2);
                        }
                        else {
                            range.setStartAfter(el);
                        }
                        range.collapse(true);
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }
                };
                if (options.selectNonEditable) {
                    element.bind('click', function (e) {
                        var range, sel, target;
                        target = e.toElement;
                        if (target !== this && angular.element(target).attr('contenteditable') === 'false') {
                            range = document.createRange();
                            sel = window.getSelection();
                            range.setStartBefore(target);
                            range.setEndAfter(target);
                            sel.removeAllRanges();
                            sel.addRange(range);
                        }
                    });
                }
                element.on('paste', function (e) {
                    e.preventDefault();
                    var clipboardData = e.originalEvent.clipboardData.getData("text/plain");
                    if (options.limitPaste) {
                        if (smsLimitReached(clipboardData)) {
                            // console.log('Pasting disabled!');
                            dialogs.notify('Paste Rejected', 'This will exceed the 480 character max. Please shorten text first.');
                            return;
                        }
                    }
                    console.log('window.clipboardData', clipboardData);
                    scope.addHTML(clipboardData, element);
                });
                element.on('keydown change', function (event) {
                    if (options.limitPaste) { // If this option is enabled we know it's for SMS so limit entering
                        var key = event.keyCode;
                        // console.log('key:' + key);
                        switch (key) {
                            case 8: // Backspace
                            case 37: // Left
                            case 38: // Up
                            case 39: // Right
                            case 40: // Down
                            case 93: // Command
                            case 17: // Ctrl
                            case 18: // Option
                                return true;
                        }
                        if (smsLimitReached(' ')) { // TODO: use string of entered character(s)
                            event.stopPropagation();
                            return false;
                        }
                    }
                });
                function smsLimitReached(addString) {
                    var html = scope.ngModel.$modelValue;
                    html = html
                        // clearing text inside of the comment tag before tags are also removed later
                        .replace(/(<comment[^>]*>)([^<]*|\n)*?(<\/comment>)/g, "$1$3")
                        // Replace line breaks with space - to count correctly
                        // First remove pair to break line
                        .replace(/<div><br[^>]*>/gi, ' ')
                        // then remove singles without div (some browsers)
                        .replace(/<br[^>]*>/gi, ' ')
                        // then remove divs that might be before above pairs (eg. <div><div><br/>... is two line breaks)
                        .replace(/<div>/gi, ' ')
                        .replace(/<\/div>/gi, '');
                    html = strip_tags(html, '');
                    return html.length + addString.length > 480;
                }
                function strip_tags(input, allowed) {
                    //   example 7: strip_tags('1 <br/> 1', '<br><br/>');
                    allowed = (((allowed || '') + '')
                        .toLowerCase()
                        .match(/<[a-z][a-z0-9]*>/g) || [])
                        .join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
                    var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
                    return input.replace(commentsAndPhpTags, '')
                        .replace(tags, function ($0, $1) {
                        // console.log('strip_tags', $0, $1, '----');
                        return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
                    });
                }
            }
        };
    }
]);
//# sourceMappingURL=contenteditable.directive.js.map